import {DTemplate} from './DTemplate.js';

export class ReloadPopup {
	static urlEncode(o) {
		let pairs = [];
		for (let k in o) {
			if (o.hasOwnProperty(k)) {
				pairs.push(`${encodeURIComponent(k)}=${encodeURIComponent(o[k])}`);
			}
		}
		return pairs.join(`&`);
	}	
	constructor(paramObject) {
		let [_, $] = DTemplate(`ReloadPopup`);
		document.head.appendChild($.css);
		document.body.appendChild($.el);
		$.el.addEventListener(`click`, evt=>{
			evt.preventDefault(); evt.stopPropagation();
			// transfer all our paramObject to the queryParams
			let queryParams = new URLSearchParams(window.location.search);
			for (let k in paramObject) {
				queryParams.delete(k);	// remove any existing value on the queryParams
				if (paramObject.hasOwnProperty(k)) {
					queryParams.set(k, paramObject[k]);
				}
			}
			queryParams.delete(`reload`);
			queryParams.set(`reload`,`true`);
    		const loc = window.location.pathname + "?" + queryParams.toString();
			window.location = loc;
		});
	}
}